import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { J1LeftarrowA, J1RightarrowA } from '@e3dc-react/icons'
import { Paper } from '@e3dc-react/shell/Elements/Paper'
import { Box } from '@mui/material'
import { useShopHorizontalScroll } from 'src/Libs/shop/hooks'
import MainComponentProductCard from './MainComponentProductCard'
import { Components, Product } from 'src/Libs/shop/models/system-configuration-components.model'

interface MainComponentCategoryCardProps {
  categoryData: Components
  onMoreInfo: (productId: string) => void
  onSelectProduct: (category: Components, product: Product) => void
  isProductSelected: (productId: string, categoryId: string) => boolean
}

const useStyles = makeStyles()(theme => ({
  gridContainer: {
    display: 'flex',
    overflowX: 'auto',
    width: '100%',
    minWidth: '30px',
    flexWrap: 'nowrap',
    marginLeft: '12px',
    position: 'relative',
  },
  paperContent: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    paddingRight: theme.spacing(5),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    overflowX: 'hidden',
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      minWidth: '100%',
      paddingRight: 0,
    },
  },
  leftArrow: {
    position: 'absolute',
    top: '50%',
    left: 0,
    transform: 'translateY(-50%)',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    padding: theme.spacing(0),
    color: theme.palette.primary.contrastText,
    minWidth: '32px',
    minHeight: '32px',
  },
  rightArrow: {
    position: 'absolute',
    top: '50%',
    right: -20,
    transform: 'translateY(-50%)',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    padding: theme.spacing(0),
    color: theme.palette.primary.contrastText,
    minWidth: '32px',
    minHeight: '32px',
  },
}))

/*
 * Displays a product category with horizontal scroll and selectable product cards
 */
const MainComponentCategoryCard: React.FC<MainComponentCategoryCardProps> = ({ categoryData, onMoreInfo, onSelectProduct, isProductSelected }) => {
  const { classes } = useStyles()
  const { containerRef, canScrollToLeft, canScrollToRight, handleScrollLeft, handleScrollRight } = useShopHorizontalScroll()

  const productsLength = categoryData.products.length

  return (
    <Paper title={`${categoryData.translated.name} (${productsLength})`} className={classes.paperContent}>
      <Box className={classes.gridContainer} ref={containerRef}>
        {categoryData.products
          .sort((a, b) => a.position - b.position)
          .map(productWrapper => (
            <MainComponentProductCard
              key={productWrapper.product.id}
              productData={productWrapper.product}
              categoryId={categoryData.id}
              categoryData={categoryData}
              onMoreInfo={onMoreInfo}
              onSelectProduct={onSelectProduct}
              isSelected={isProductSelected(productWrapper.product.id, categoryData.id)}
            />
          ))}
      </Box>

      {canScrollToLeft && <J1LeftarrowA className={classes.leftArrow} onClick={handleScrollLeft} />}
      {canScrollToRight && <J1RightarrowA className={classes.rightArrow} onClick={handleScrollRight} />}
    </Paper>
  )
}

export default MainComponentCategoryCard
